import React from 'react';
import { Helmet } from 'react-helmet-async';

interface ImageWithSchemaProps {
  src: string;
  alt: string;
  className?: string;
  imageName: string;
  imageDescription: string;
  serviceType: string;
  location?: string;
  beforeAfter: 'before' | 'after';
}

const ImageWithSchema: React.FC<ImageWithSchemaProps> = ({
  src,
  alt,
  className = '',
  imageName,
  imageDescription,
  serviceType,
  location = 'Ventura County',
  beforeAfter
}) => {
  const imageSchema = {
    "@context": "https://schema.org",
    "@type": "ImageObject",
    "contentUrl": `https://www.venturapowerwashing.com${src}`,
    "url": `https://www.venturapowerwashing.com${src}`,
    "name": imageName,
    "description": imageDescription,
    "caption": alt,
    "creator": {
      "@type": "Organization",
      "name": "Ventura Power Washing"
    },
    "copyrightHolder": {
      "@type": "Organization", 
      "name": "Ventura Power Washing"
    },
    "uploadDate": "2024-01-01",
    "keywords": [
      `${serviceType} ${location}`,
      `${beforeAfter} ${serviceType}`,
      `professional cleaning ${location}`,
      "pressure washing ventura",
      "cleaning services"
    ],
    "width": "400",
    "height": "300",
    "encodingFormat": "image/png"
  };

  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(imageSchema)}
        </script>
      </Helmet>
      <img 
        src={src}
        alt={alt}
        className={className}
        itemProp="image"
      />
    </>
  );
};

export default ImageWithSchema;